import { createContext, useContext, useEffect, useState } from "react";

const MetronicSplashScreenContext = createContext();

export function MetronicSplashScreenProvider({ children }) {
  const [count, setCount] = useState(0);
  let visible = count > 0;

  useEffect(() => {
    const splashScreen = document.getElementById("splash-screen");

    // Show SplashScreen
    if (splashScreen && visible) {
      splashScreen.classList.remove("hidden");

      return () => {
        splashScreen.classList.add("hidden");
      };
    }

    // Hide SplashScreen
    let timeout;
    if (splashScreen && !visible) {
      timeout = setTimeout(() => {
        splashScreen.classList.add("hidden");
      }, 0);
    }

    return () => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      clearTimeout(timeout);
    };
  }, [visible]);

  return (
    <MetronicSplashScreenContext.Provider value={setCount}>
      {children}
    </MetronicSplashScreenContext.Provider>
  );
}

export function LayoutSplashScreen({ visible = true }) {
  // Everything are ready - remove splashscreen
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const setCount = useContext(MetronicSplashScreenContext);

  useEffect(() => {
    if (!visible) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    setCount((prev) => {
      return Number(prev) + 1;
    });

    return () => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      setCount((prev) => {
        return Number(prev) - 1;
      });
    };
  }, [setCount, visible]);

  return null;
}
